<li class="stepper2">
    @if(job && job.tasks){
    @for(task of job.tasks; track $index){



    @let competedPending = task.status === "COMPLETED" && job.status === "PENDING" && job.tasks[$index + 1].status ===
    'PENDING' ?
    'COMPLETED-PENDING' : task.status;

    <ul [ngClass]="competedPending">
        <div class="bar">
            <span class="circle"></span>
            <div class="progress-bar">
                <div class="progress" [ngStyle]="{'width':task.progress + '%'}"></div>
            </div>
        </div>
        <div class="content">
            <p class="name">{{'task_type.' + task.type + '.title' | translate}}</p>
            <p class="description">{{'task_type.' + task.type + '.description' | translate}}</p>
        </div>
    </ul>
    }
    <span class="circle" [ngClass]="job.completed ? 'COMPLETED' : 'PENDING'"></span>
    }
</li>